import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import get from 'lodash/get'
import FormWrapper from './FormWrapper'

const FormWrapperContainer = (props) => {
  return (
    <FormWrapper
      config={props.config}
      area={props.area}
      themeColorHex={props.themeColorHex}
      onSubmit={props.onSubmit}
      showPrivacyMsg={props.showPrivacyMsg}
      customValidation={props.customValidation}
      submitBtnLabel={props.submitBtnLabel}
      errors={props.errors}
      itemId={props.itemId}
      form={props.form}
      initialValues={props.initialValues}
      title={props.title}
      successMessage={props.successMessage} >
      {React.cloneElement(props.children, {config: props.config, errors: props.errors})}
    </FormWrapper>
  )
}

FormWrapperContainer.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  showPrivacyMsg: PropTypes.bool.isRequired,
  customValidation: PropTypes.func,
  submitBtnLabel: PropTypes.string,
  errors: PropTypes.object,
  itemId: PropTypes.number,
  form: PropTypes.string.isRequired,
  title: PropTypes.string,
  initialValues: PropTypes.object,
  successMessage: PropTypes.string
}

function mapStateToProps(state, props) {
  const { campaign, form, lead } = state
  const { config, form: formName } = props
  const currentForm = form[formName]
  const anonymous_lead = lead.anon_guest
  const shouldAutoFill = get(config, 'form.auto_fill', false)
  const leadInitialValues = anonymous_lead ? null : {
    email: lead.email,
    name: lead.name,
    last_name: lead.last_name,
    headline: lead.headline,
    company: lead.company,
    phone: lead.phone,
  }
  const preDefinedInitialValues = props.initialValues

  return {
    initialValues: preDefinedInitialValues ? preDefinedInitialValues
                    : (shouldAutoFill ? leadInitialValues : null),
    themeColorHex: campaign.themeColorHex,
    showPrivacyMsg: (
      !!get(config.privacy_message, 'message')
      && !!get(currentForm, 'registeredFields.email', false)
    ),
    errors: get(currentForm, 'submitErrors', {})
  }
}

export default connect(mapStateToProps, null)(FormWrapperContainer)